import { render } from "./PasswordReset.vue?vue&type=template&id=75a9de07"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"
script.render = render

export default script